import CallCentreApi from '@/api/CallCentreApiAxiosPlugin'
import { log } from '@/lib/logging'

export interface ICreateSignalRConnection {
  url: string
  accessToken: string
  ttl: number
}

export default class SignalRController {
  public static async Connect(hubName: string): Promise<ICreateSignalRConnection | null> {
    try {
      const res = await CallCentreApi.post<ICreateSignalRConnection>('signalr/connect', {
        hubName,
      })
      if (res.status !== 200) {
        return null
      }
      return res.data
    } catch (error) {
      log('Error connecting to SignalR', { level: 'error', error })
      return null
    }
  }
}
